import { createFileRoute } from '@tanstack/react-router'
import { lazy } from 'react'

import { assertDevelopmentBuild, DevPreviewUnavailable } from '@/spa/dev-only'

// The ternary is folded by Rollup in a production build, so the preview chunk
// is never emitted. See DevPreviewUnavailable in @/spa/dev-only.
const component = import.meta.env.DEV
  ? lazy(() =>
      import('@/features/federal-tax/pages/dev-wizard-preview').then((m) => ({ default: m.FederalTaxWizardPreview })),
    )
  : DevPreviewUnavailable

export const Route = createFileRoute('/_bare/dev/federal-tax-wizard-preview')({
  beforeLoad: assertDevelopmentBuild,
  component,
})
